export default __webpack_public_path__ + "ea61b99569ad51a91ebacaa7b53b48ee.png";